import styled from 'styled-components';

export const Embed = styled.span`
  padding: 0em 0.2em;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 5px;
  font-family: monospace;
  font-size: 1rem;
`;
